import React from 'react';
import FieldSelect from '../FieldSelect/FieldSelect';
import { TalentType } from '../../util/enums';
import css from './CustomExtendedDataField.module.css';
import { sortOptionsByKeyIntl } from '../../util/genericHelpers';

function RenderTalentTypes({
  name,
  formId,
  label,
  validateMaybe,
  placeholder,
  filterOptions,
  dependentValue,
}) {
  const isTalentLevelField = name === 'pub_talent_level';
  const selectedTalentType = dependentValue ? dependentValue.toLowerCase() : '';

  // If it's Talent Level field:
  // - Don't show if Talent Type is not selected
  // - Don't show if Talent Type is not Athlete or Coach
  if (
    isTalentLevelField &&
    (!selectedTalentType ||
      (selectedTalentType !== TalentType.ATHLETE && selectedTalentType !== TalentType.COACH))
  ) {
    return null;
  }

  return (
    <FieldSelect
      className={css.customField}
      name={name}
      id={formId ? `${formId}.${name}` : name}
      label={label}
      {...validateMaybe}
    >
      <option disabled value="">
        {placeholder}
      </option>
      {sortOptionsByKeyIntl(filterOptions, 'label', name).map(({ value, label }) => (
        <option key={`${value}_${label}`} value={value}>
          {label}
        </option>
      ))}
    </FieldSelect>
  );
}

export default RenderTalentTypes;
